var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-dialog', _vm._b({ staticClass: "scene-node-dialog", attrs: { "visible": _vm.dialogProps.visible }, on: { "update:visible": function updateVisible($event) {
        return _vm.$set(_vm.dialogProps, "visible", $event);
      } } }, 'el-dialog', _vm.dialogProps, false), [_c('scenc-node-trees', { attrs: { "treeProps": _vm.treeProps, "current-node-key": _vm.selectTargetId, "popDisabled": true }, on: { "select": _vm.handleCurrentChange } }), _vm._v(" "), _c('el-button', { staticClass: "confirm", attrs: { "type": "primary" }, on: { "click": _vm.okHandler } }, [_vm._v("确定")])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };